/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BaseApplication } from "./base/baseApplication";
import { UnitTest } from "./unit.test";
import {
  AppNavigatorService,
  LandingPageService,
  PrivacyPageService,
  TermsPageService,
  FullProvenancePageService,
  GetOCRPageService,
  GetProductDetailPageService,
  ProvenanceDetailPageService
} from "../services";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { DEFAULT_APP_SRC_CONFIG } from "../config/default.config";

export class VApplication extends BaseApplication {
  private static instance: VApplication;

  private constructor(options: any = {}) {
    super(options);

    this.setupBindings();

    //Modules
    this.initModules();

    //Services
    this.initServices();
  }

  static getInstance(options: any = {}) {
    if (!this.instance) {
      this.instance = new VApplication(options);
    }
    return this.instance;
  }

  // @ts-ignore
  async start() {
    await this.initRunLevel();
    await this.unitTest();
  }

  setupBindings() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
    const storageService = StorageModule.getInstance();
    const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");

    console.log(`.env content: `, DEFAULT_APP_CONFIG);

    this.configure("services.FullProvenancePageService", {
      fullProvenanceRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.restServer?.baseURL,
      getTemplateRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.restServer?.ocrBaseURL
      //fullProvenanceRestAPI: "https://kiran-2.vlinderserver.online/trag"
    });
    this.configure("services.GetOCRPageService", {
      getOCRRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.restServer?.ocrBaseURL
    });
    this.configure("services.GetProductDetailPageService", {
      productDetailRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.restServer?.baseURL,
    });
    this.configure("services.ProvenanceDetailPageService", {
      verifyCredentialRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.restServer?.baseURL,
    });
  }

  async initRunLevel() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
    const storageService = StorageModule.getInstance();
    const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
    const graphqlModule = this.getSync(
      "services.GraphqlServerModule"
    ) as GraphqlServerModule;

    // if (graphqlModule) {
    //   type TClient = typeof DEFAULT_APP_SRC_CONFIG.servers.graphql[0];
    //   DEFAULT_APP_SRC_CONFIG?.servers.graphql.forEach((client: TClient) => {
    //     graphqlModule
    //       .createClient(client.name, {
    //         url: client.url,
    //         //url: "https://kiran.vlinderserver.online/org-core/",
    //         getContext: this.getGraphQLContext.bind(this),
    //       })
    //       .then((res) => {
    //         console.log(`initRunLevel check`, res);
    //       })
    //       .catch((err) => {
    //         console.log(`error in initRunLevel  ${err.message}`);
    //       });
    //   });
    // }
  }

  async unitTest() {
    const ut = new UnitTest(VApplication);
    ut.run();
  }

  initModules() {
    this.service("services.EventBusModule", EventBusModule);
    this.service("services.GraphqlServerModule", GraphqlServerModule);
  }

  initServices() {
    this.service("services.AppNavigatorService", AppNavigatorService);
    this.service("services.LandingPageService", LandingPageService);
    this.service("services.PrivacyPageService", PrivacyPageService);
    this.service("services.TermsPageService", TermsPageService);
    this.service(
      "services.FullProvenancePageService",
      FullProvenancePageService
    );
    this.service("services.GetOCRPageService", GetOCRPageService);
    this.service("services.GetProductDetailPageService", GetProductDetailPageService);
    this.service("services.ProvenanceDetailPageService", ProvenanceDetailPageService);
  }

  private getGraphQLContext() {
    // const loginService = this.getSync(
    //   "services.AppNavigatorService"
    // ) as AppNavigatorService;
    //let token = loginService?.getToken();
    //FIXME:
    // if (token) {
    return {
      headers: {
        headers: {
          // ...{ ...deviceInfoService?.getDeviceInfo() },
          // ...{ ...deviceInfoService?.getAppInfo() },
          
        },
      },
    };
    // } else {
    //   return {
    //     headers: {
    //       headers: {
    //         // ...{ ...deviceInfoService?.getDeviceInfo() },
    //         // ...{ ...deviceInfoService?.getAppInfo() },
    //       },
    //     },
    //   };
    // }
  }
}
